import { useEffect, useRef, useState } from 'react';

export const useSwiperLogic = () => {
  const swiperRef = useRef<any>(null);
  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null);
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null);
  const [isClickedPrevBtn, setIsClickedPrevBtn] = useState(false);
  const [isClickedNextBtn, setIsClickedNextBtn] = useState(false);
  const [isEnd, setIsEnd] = useState(true);
  const [isBegin, setIsBegin] = useState(true);
  const [isShowNavigation, setIsShowNavigation] = useState(true);
  const swiperSlides = swiperRef?.current?.swiper?.slides;
  const handleClickNextBtn = () => {
    const swiperInstance = swiperRef?.current?.swiper;
    swiperInstance?.slideNext();
    if (swiperRef?.current?.swiper?.isEnd) {
      setIsEnd(true);
    }

    setIsClickedNextBtn(true);
    setTimeout(() => setIsClickedNextBtn(false), 300);
  };

  const handleClickPrevBtn = () => {
    const swiperInstance = swiperRef?.current?.swiper;
    swiperInstance?.slidePrev();
    if (swiperRef?.current?.swiper?.isBeginning) {
      setIsBegin(true);
    }

    setIsClickedPrevBtn(true);
    setTimeout(() => setIsClickedPrevBtn(false), 300);
  };

  const handleReachEnd = () => {
    const swiperInstance = swiperRef?.current?.swiper;
    if (swiperInstance) {
      setIsEnd(true);
    }
  };

  const handleReachBeginning = () => {
    const swiperInstance = swiperRef?.current?.swiper;
    if (swiperInstance) {
      setIsBegin(true);
    }
  };

  useEffect(() => {
    const swiperInstance = swiperRef?.current?.swiper;
    const updateNavigationButtons = () => {
      if (swiperInstance) {
        setIsBegin(swiperInstance.isBeginning);
        setIsEnd(swiperInstance.isEnd);
      }
    };
    if (swiperInstance) {
      const totalSlidesWidth = swiperInstance.slides?.reduce(
        (total: number, slide: any) => total + slide.clientWidth + 16,
        0,
      );
      const containerWidth = swiperInstance.width;
      setIsShowNavigation(totalSlidesWidth > containerWidth);
      swiperInstance.on('slideChange', updateNavigationButtons);
      swiperInstance.on('reachEnd', () => setIsEnd(true));
      swiperInstance.on('reachBeginning', () => setIsBegin(true));
      swiperInstance.on('fromEdge', () => {
        setIsBegin(false);
        setIsEnd(false);
      });
      return () => {
        swiperInstance.off('slideChange', updateNavigationButtons);
      };
    }
  }, []);

  useEffect(() => {
    const swiperInstance = swiperRef?.current?.swiper;
    if (swiperInstance) {
      setIsBegin(swiperInstance.isBeginning);
      setIsEnd(swiperInstance.isEnd);
      const totalSlidesWidth = swiperInstance.slides?.reduce(
        (total: number, slide: any) => total + slide.clientWidth + 16,
        0,
      );
      const containerWidth = swiperInstance.width;
      setIsShowNavigation(totalSlidesWidth > containerWidth);
    }
  }, [swiperSlides?.length]);

  return {
    swiperRef,
    isEnd,
    isBegin,
    isShowNavigation,
    isClickedNextBtn,
    handleReachBeginning,
    handleReachEnd,
    isClickedPrevBtn,
    prevEl,
    nextEl,
    setPrevEl,
    setNextEl,
    handleClickNextBtn,
    handleClickPrevBtn,
  };
};
